{
  "pending": "قيد الانتظار"
}
